import React, { useEffect, useState } from "react"
import submitHandler from "../../services/submitHandler"
import { ConfigProvider, Modal, theme } from "antd"
import settingsStore from "../../stores/settingsStore"
import botStore from "../../stores/botStore"
// () => submitHandler.edit(bannerId, texts, imageFile)

function calculateVariablesPriceDiff(
    oldVariables,
    newVariables,
    settings,
    expiresInDays,
    ranksystemIsUnchecked
) {
    if (expiresInDays <= 0) return 0

    const keyToPriceMap = new Map(settings.map((s) => [s.name, s.price]))
    const oldVariablesIdSet = new Set(oldVariables.map((v) => v.id))
    const newVariablesIdSet = new Set(newVariables.map((v) => v.id))

    const variablesToAdd = newVariables.filter((v) => !oldVariablesIdSet.has(v.id))
    const variablesToRemove = oldVariables.filter((v) => !newVariablesIdSet.has(v.id))

    let priceToAdd = 0
    let priceToRemove = 0

    let calculationDescLines = []

    if (ranksystemIsUnchecked) {
        calculationDescLines.push({
            type: "remove",
            text: "مبلفی بابت حذف رنک سیستم برگردانده نمیشود \n",
        })
    }

    for (let variable of variablesToAdd) {
        const variableMonthPrice = keyToPriceMap.get(variable.key) || 0
        const variablePriceTillExpire = Math.floor((variableMonthPrice / 30) * expiresInDays)

        calculationDescLines.push({
            type: "remove",
            text: `مقدار ${variablePriceTillExpire} از حساب شما بابت اضافه کردن متغیر ${variable.key} کسر میشود`,
            price: variablePriceTillExpire,
        })

        priceToRemove += variablePriceTillExpire
    }

    for (let variable of variablesToRemove) {
        const variableMonthPrice = keyToPriceMap.get(variable.key) || 0
        const variablePriceTillExpire = Math.floor((variableMonthPrice / 30) * expiresInDays)

        calculationDescLines.push({
            type: "add",
            text: `مقدار ${variablePriceTillExpire} به حساب شما بابت حذف متغیر ${variable.key} اضافه میشود`,
            price: variablePriceTillExpire,
        })

        priceToAdd += variablePriceTillExpire
    }

    return { calculatedPrice: priceToAdd - priceToRemove, calculationDescLines }
}

const EditButton = ({
    banner,
    texts,
    imageFile,
    oldVariables,
    useRanksystem,
    ranksystemConfig,
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [variables, setVariables] = useState([])
    const [calculation, setCalculation] = useState(0)

    const settings = settingsStore((state) => state.settings)
    const bot = botStore((state) => state.bot)

    useEffect(() => {
        if (isOpen) {
            const newVariables = texts.map((t) => ({
                id: t.id,
                key: t.variable.key,
                fill: t.fill,
                fontSize: t.fontSize,
                fontWeight: t.fontWeight,
                fontFamily: t.fontFamily,
                rotation: t.rotation,
                x: t.x,
                y: t.y,
                options: t.options,
            }))

            setVariables(newVariables)

            let ranksystemIsUnchecked = banner.useRanksystem && !useRanksystem

            const diff = calculateVariablesPriceDiff(
                oldVariables,
                newVariables, // Use the local variable, not state
                settings,
                bot.expiresInDays,
                ranksystemIsUnchecked
            )

            setCalculation(diff)
        }
    }, [isOpen])

    const toggleModal = () => setIsOpen(!isOpen)

    return (
        <>
            <button onClick={toggleModal} className="btn btn-success outline-none">
                ویرایش بنر
            </button>
            <ConfigProvider direction="rtl" theme={{ algorithm: theme.darkAlgorithm }}>
                <Modal
                    title="ویرایش بنر"
                    open={isOpen}
                    onCancel={toggleModal}
                    onOk={() => {
                        toggleModal()
                        submitHandler.edit(
                            banner.id,
                            variables,
                            imageFile,
                            useRanksystem,
                            ranksystemConfig
                        )
                    }}
                    okText={"ویرایش"}
                    cancelText={"بیخیال!"}
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <div className="flex justify-between mx-2">
                                <div>
                                    مجموع: {calculation?.calculatedPrice?.toLocaleString("en-US")}{" "}
                                    تومان
                                </div>
                                <div className="flex gap-2">
                                    <CancelBtn />
                                    <OkBtn />
                                </div>
                            </div>
                        </>
                    )}
                >
                    <div>تعداد روز باقیمانده از بات بنر داینامیک شما: {bot.expiresInDays} روز</div>
                    <div className="bg-stone-800 mt-5 p-2 border-sky-500 border-2 rounded-md">
                        {calculation &&
                            calculation.calculationDescLines.map(({ type, text }) => (
                                <div
                                    className={
                                        type == "remove" ? `text-rose-500` : "text-green-500"
                                    }
                                >
                                    {text}
                                </div>
                            ))}
                    </div>
                </Modal>
            </ConfigProvider>
        </>
    )
}

export default EditButton
